
import React from 'react';
import { Typography } from '@mui/material';
import { COLOR_ACCENT_1 } from 'src/const';
import { abbreviateNumber } from 'src/utils/functions';

const ClusterPointer = ({
  id,
  lat,
  lng,
  pointSize,
  totalListingsNumInThisCluster,
}: {
  id: number;
  lat: number;
  lng: number;
  pointSize: number;
  totalListingsNumInThisCluster: number;
}) => {
  const ClusterPointerWrapper = (props: any) => props.children;

  return (
      <div
        className="cluster-marker"
        key={`cluster-${id}`}
        style={{
          width: `${pointSize}px`,
          height: `${pointSize}px`,
          maxWidth: '50px',
          maxHeight: '50px',
          backgroundColor: COLOR_ACCENT_1,
          borderRadius: 9000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
          outline: `5px solid ${COLOR_ACCENT_1}55`,
        }}
        onClick={() => {}}
      >
        <Typography variant="caption" style={{ fontWeight: 'bold', color: '#fff' }}>
          {abbreviateNumber(totalListingsNumInThisCluster, false)}
          {totalListingsNumInThisCluster > 1000 ? '+' : ''}
        </Typography>
      </div>
  );
};

export default ClusterPointer;
